import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { formatearFecha, formatearMoneda } from '../helpers/helper'
import Precios from '../reutilizables/precios/Precios'
import { buscarMedioPago } from '../servicios/publicacionesService'
import styles from './DetallePago.module.css'

const PAGO_CON_TARJETA_CREDITO = 2

const DetallePago = (props) => {
  const { pedidoItem, fechaPedido } = props
  const [medioPago, setMedioPago] = useState({})

  const recibirMediosPago = async () => {
    const { data } = await buscarMedioPago()
    setMedioPago(data.find((m) => m.idMedioPago === pedidoItem.idMedioPago))
  }

  useEffect(() => {
    if (Object.keys(medioPago).length === 0 && pedidoItem) {
      recibirMediosPago()
    }
  }, [])

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="row">
            <div className="col">
              <h3 className="text-left">Detalle de Pago</h3>
            </div>
          </div>
          <div className="row detalle-pago">
            <div className="col">
              <div className="row">
                <div className="col">
                  <p>
                    <span className="icon-detalle-pago">
                      <i className="fa fa-user fa-fw" aria-hidden="true" />
                    </span>
                    <strong>Comprador:</strong> {pedidoItem.compradorNombre}
                  </p>
                </div>
                <div className="col">
                  <p>
                    <span className="icon-detalle-pago">
                      <i className="fa fa-calendar-o fa-fw" aria-hidden="true" />
                    </span>
                    <strong> Fecha de Pedido: </strong>
                    {formatearFecha(fechaPedido, 'F')}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <p>
                    <span className="icon-detalle-pago">
                      <i
                        className={medioPago?.icono || 'fa fa-credit-card'}
                        aria-hidden="true"
                      />
                    </span>
                    <span>
                      <strong> Medio de Pago: </strong>
                      {` ${
                        pedidoItem.idMedioPago === PAGO_CON_TARJETA_CREDITO
                          ? `**** **** **** ${pedidoItem.numTarjetaCredito}`
                          : medioPago?.nombre || ''
                      }`}
                    </span>
                  </p>
                </div>
                <div className="col">
                  <div className={styles.precioTotal}>
                    <span className="icon-detalle-pago">
                      <i className="fa fa-shopping-cart fa-fw" aria-hidden="true" />
                    </span>
                    <Precios
                      nombre="Total producto"
                      precio={pedidoItem.precioUnitario}
                      monedaSimbolo={formatearMoneda(pedidoItem.monedaSimbolo)}
                      alicuota={pedidoItem.alicuota}
                      cantidad={pedidoItem.cantidad || 1}
                      mostrarCantidad
                      showSinIVA={true}
                    />
                  </div>
                  {pedidoItem.envioTipo && (
                    <div className={styles.precioEnvio}>
                      {pedidoItem.precioEnvio > 0 && (
                        <>
                          <span className="icon-detalle-pago">
                            <i className="fa fa-truck fa-fw" aria-hidden="true" />
                          </span>
                          <Precios
                            nombre={pedidoItem.envioTipo}
                            precio={pedidoItem.precioEnvio}
                            monedaSimbolo={formatearMoneda(pedidoItem.monedaSimbolo)}
                            alicuota={21}
                            className="m-0"
                            showSinIVA={true}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {Boolean(pedidoItem.entregaLocalidad) && (
                <>
                  <p className="">
                    <span className="icon-detalle-pago">
                      <i className="fa fa-home fa-fw" aria-hidden="true" />
                    </span>
                    <strong>Domicilio: </strong>
                    {pedidoItem.entregaCalle}, {pedidoItem.entregaCalleAltura},
                    {pedidoItem.entregaLocalidad}, {pedidoItem.entregaProvincia}
                  </p>
                </>
              )}
              <div className="row">
                <div className="col-6">
                  {pedidoItem.numComprobantePago && (
                    <p className="">
                      <span className="icon-detalle-pago">
                        <i className="fa fa-file-text-o fa-fw" aria-hidden="true" />
                      </span>
                      <strong>Número de comprobante: </strong>{' '}
                      {pedidoItem.numComprobantePago}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  )
}

DetallePago.propTypes = {
  pedidoItem: PropTypes.shape({
    idMedioPago: PropTypes.number.isRequired,
    compradorNombre: PropTypes.string.isRequired,
    numTarjetaCredito: PropTypes.string,
    monedaSimbolo: PropTypes.string.isRequired,
    precioUnitario: PropTypes.number.isRequired,
    precioEnvio: PropTypes.number,
    numComprobantePago: PropTypes.string.isRequired,
    entregaLocalidad: PropTypes.string,
    entregaCalle: PropTypes.string,
    entregaCalleAltura: PropTypes.string,
    entregaProvincia: PropTypes.string,
    idMedioEnvio: PropTypes.number.isRequired,
    envioTipo: PropTypes.string.isRequired,
    cantidad: PropTypes.number.isRequired,
    alicuota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired,
  fechaPedido: PropTypes.string.isRequired
}

export default DetallePago
